"use strict";

exports.__esModule = true;
exports.EmptyTimelineNote = EmptyTimelineNote;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Below this the note would not fit; the empty track alone has to do.
var MIN_HEIGHT = 16;
var Note = _styledComponents["default"].div.withConfig({
  displayName: "EmptyTimelineNote__Note",
  componentId: "sc-wc0nic-0"
})(["position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;font-size:11px;letter-spacing:0.01em;color:", ";white-space:nowrap;"], (0, _Theme.val)("ChartCardSubtitleColor"));

/**
 * Sits over an empty stripe chart so a bare track reads as "no data" rather
 * than as a broken card. Render it inside a positioned box of the chart's
 * size; it draws nothing when the box is too short for a line of text.
 */
function EmptyTimelineNote(_ref) {
  var height = _ref.height,
    children = _ref.children;
  if (height != null && height < MIN_HEIGHT) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(Note, {
    "data-testid": "EmptyTimelineNote"
  }, children || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "StripeChart.empty",
    defaultMessage: "No data for this period"
  }));
}